import { useMemo, useState } from "react";

const normalizeRange = (start, end) => {
  const minRow = Math.min(start.rowIndex, end.rowIndex);
  const maxRow = Math.max(start.rowIndex, end.rowIndex);
  const minCol = Math.min(start.colIndex, end.colIndex);
  const maxCol = Math.max(start.colIndex, end.colIndex);
  return {
    start: { rowIndex: minRow, colIndex: minCol },
    end: { rowIndex: maxRow, colIndex: maxCol },
  };
};

export const useGridSelection = () => {
  const [anchorCell, setAnchorCell] = useState(null);
  const [activeCell, setActiveCell] = useState(null);

  const range = useMemo(() => {
    if (!anchorCell || !activeCell) {
      return null;
    }
    return normalizeRange(anchorCell, activeCell);
  }, [anchorCell, activeCell]);

  const setSingleCell = (cell) => {
    setAnchorCell(cell);
    setActiveCell(cell);
  };

  const setRangeEnd = (cell) => {
    if (!anchorCell) {
      setSingleCell(cell);
      return;
    }
    setActiveCell(cell);
  };

  const isCellInRange = (rowIndex, colIndex) => {
    if (!range) {
      return false;
    }

    return (
      rowIndex >= range.start.rowIndex &&
      rowIndex <= range.end.rowIndex &&
      colIndex >= range.start.colIndex &&
      colIndex <= range.end.colIndex
    );
  };

  return {
    anchorCell,
    activeCell,
    range,
    setSingleCell,
    setRangeEnd,
    isCellInRange,
  };
};
